import { createRouter } from "@tanstack/react-router";

import { embeddedAdminPrefix, storeBasePath } from "@go-novus/admin-api";

import { boundShopDomain } from "#/shared/lib/bound-store";

import { routeTree } from "./routeTree.gen";

export function createAppRouter() {
  const shop = boundShopDomain();
  const prefix = window.location.pathname.startsWith(`${embeddedAdminPrefix}/`)
    ? embeddedAdminPrefix
    : "";
  return createRouter({
    // 两种入口共用路由树，页面本身不用感知店铺段和内嵌前缀。
    basepath: shop === null ? "/" : `${prefix}${storeBasePath(shop)}`,
    defaultPreload: "intent",
    routeTree,
    scrollRestoration: true,
  });
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}
